import React, { FC } from 'react';
import { ReactComponent as Allocated } from '../../../assets/ClientCheck/Allocated.svg';

export const AllocatedIcon: FC = () => <Allocated />;
